var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { observable, computed } from 'mobx';
import { QuestionType } from '@common/enums/base';
var Question = /** @class */ (function () {
    function Question(entity) {
        var _this = this;
        Object.keys(entity).forEach(function (key) { return _this[key] = entity[key]; });
        if (this.QuestionTypeId === QuestionType.Select || this.QuestionTypeId === QuestionType.LimitSelect) {
            this.answerId = this.QuestionOptions[0].Id;
        }
        this.SubQuestions = this.SubQuestions.map(function (question) { return new Question(question); });
        this.QuestionOptions.forEach(function (option) { option.SubQuestions = option.SubQuestions.map(function (question) { return new Question(question); }); });
    }
    Object.defineProperty(Question.prototype, "optionQuestionsRaw", {
        get: function () {
            var _this = this;
            var option = this.QuestionOptions.find(function (option) { return option.Id === _this.answerId; });
            var allQuestions = [];
            if (option != null) {
                allQuestions = option.SubQuestions.concat(); // concat for copy.
                this.QuestionTypeId === QuestionType.LimitSelect /* Limit Question Select */ && allQuestions.splice(parseInt(option.Name, 10));
            }
            return allQuestions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "optionQuestions", {
        get: function () {
            return displayOneByOne(this.optionQuestionsRaw);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "subQuestions", {
        get: function () {
            return displayOneByOne(this.SubQuestions);
        },
        enumerable: false,
        configurable: true
    });
    Question.serialization = function (questions) {
        return questions.map(function (question) { return new Question(question); });
    };
    Question.toAnswer = function (questions, verbose) {
        var answers = [];
        questions.forEach(function (question) {
            var answer = {
                QuestionId: question.Id,
                QuestionOptionId: question.answerId,
                Answer: question.answer,
            };
            if (verbose) {
                answer.Question = question;
                if (answer.QuestionOptionId) {
                    answer.QustionOption = question.QuestionOptions.find(function (option) { return option.Id === answer.QuestionOptionId; });
                }
            }
            answers.push(answer);
            if (question.optionQuestionsRaw.length > 0)
                answers = __spreadArrays(answers, Question.toAnswer(question.optionQuestionsRaw, verbose));
            if (question.SubQuestions.length > 0)
                answers = __spreadArrays(answers, Question.toAnswer(question.SubQuestions, verbose));
        });
        return answers;
    };
    Question.fromAnswer = function (questions, answers) {
        if (questions.length === 0)
            return;
        if (answers) {
            answers.forEach(function (answer) {
                questions.filter(function (question) { return question.Id === answer.QuestionId; }).forEach(function (question) {
                    question.answer = answer.Answer;
                    question.answerId = answer.QuestionOptionId;
                    Question.fromAnswer(question.SubQuestions, answers);
                    Question.fromAnswer(question.optionQuestionsRaw, answers);
                });
            });
        }
    };
    __decorate([
        observable
    ], Question.prototype, "answer", void 0);
    __decorate([
        observable
    ], Question.prototype, "answerId", void 0);
    __decorate([
        computed
    ], Question.prototype, "optionQuestionsRaw", null);
    __decorate([
        computed
    ], Question.prototype, "optionQuestions", null);
    __decorate([
        computed
    ], Question.prototype, "subQuestions", null);
    return Question;
}());
var displayOneByOne = function (questions) {
    var result = [];
    for (var i = 0; i < questions.length; i += 1) {
        var question = questions[i];
        result.push(question);
        if (!isQuestionAnswered(question) && questions[i + 1]) {
            break;
        }
    }
    return result;
};
var isQuestionAnswered = function (question) {
    if (!question.answer && !question.answerId) {
        return false;
    }
    for (var _i = 0, _a = question.optionQuestionsRaw; _i < _a.length; _i++) {
        var subQuestion = _a[_i];
        if (!isQuestionAnswered(subQuestion)) {
            return false;
        }
    }
    for (var _b = 0, _c = question.SubQuestions; _b < _c.length; _b++) {
        var subQuestion = _c[_b];
        if (!isQuestionAnswered(subQuestion)) {
            return false;
        }
    }
    return true;
};
export default Question;
